class TextConstants {
    public static PROFILE_TITLE = "That's me, baby";
    public static CategoryResultFlavourTextOptions = [
        "Interesting, it looks like you’re a...",
        "Based on our calculations, you’re a...",
        "Ooh, so you’re a...",
        "Has anyone ever told you that you’re a...",
        "We think that you’re a...",
        "Nice, it looks like you’re a...",
    ];
}

export { TextConstants }